/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function () {
	class Logger {
		constructor(options = { error:true }) {
			this.options = options;
			this._logger = console;
		}
		getAPI() {
			const that = this;
			return {
				log: function() {
					if (that.options.log) {
						that._logger.log.apply(that._logger, arguments);
					}
				},
				debug: function() {
					if (that.options.debug) {
						that._logger.log.apply(that._logger, arguments);
					}
				},
				error: function() {
					if (that.options.error) {
						that._logger.log.apply(that._logger, arguments);
					}
				},
				info: function() {
					if (that.options.info) {
						that._logger.log.apply(that._logger, arguments);
					}
				},
				warn: function() {
					if (that.options.warn) {
						that._logger.log.apply(that._logger, arguments);
					}
				}
			};
		}
	}
	return Logger;
});
